import TextContainer from "@client/content/Containers/Text/container";
import { RedirectLinkEntity } from "@client/content/controls/Link/Redirect/container";
import { getContainerProps, getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";

export type ContentIconComponentProps = RootContainerProps & {
  className: string;
  style?: React.CSSProperties;
};

export default (props: ContentIconComponentProps) => (
  <TextContainer {...getContainerProps(props)}>
    <RedirectLinkEntity {...getEntityRef(props)}>
      <i className={props.className} style={props.style} />
    </RedirectLinkEntity>
  </TextContainer>
);
